/* eslint-disable no-debugger, guard-for-in */
import Vue from 'vue';

// TODO: remove features/debug?
// computed: mapGetters({
// 	debugFlags: 'features/debug',
// }),

const watchChanges = (instance = Vue) => {
	for (const prop in instance) {
		instance.$watch(
			() => instance[prop],
			(newVal, oldVal) => {
				if (prop === '$attrs') return;
				instance.$log(`@change ${prop}`, { before: oldVal, after: newVal });
				if (instance._debugOptions.debugOnChange === true) debugger;
				if (typeof instance._debugOptions.onChange === 'function' && instance._debugOptions.onChange(prop, newVal, oldVal)) {
					debugger;
				}
			}
		);
	}
	if (instance.$parent) watchChanges(instance.$parent);
};

const defaultDebugOptions = {
	log:           true,
	lifecycle:     false,
	changes:       false,
	debugOnChange: false,
	onChange:      null,
};

const mixin = {
	created() {
		if (this._debugOptions.changes) {
			watchChanges(this);
		}
	},
	mounted() {
		if (this._debugOptions.lifecycle) {
			this.$log('mounted()', this);
		}
	},
	updated() {
		if (this._debugOptions.lifecycle) {
			this.$log('updated()', this);
		}
	},
	computed: {
		_debugOptions() {
			if (!this.$options.debug) return {};
			return { ...defaultDebugOptions, ...(typeof this.$options.debug === 'object' ? this.$options.debug : {}) };
		},
	},
	methods: {
		$log(...args) {
			if (!this._debugOptions.log) return;

			const componentName = this.$options.name ?? 'Unknown';
			const time = new Date().toLocaleTimeString();

			console.log(
				`%c Log %c ${time} %c ${componentName} %c`,
				'background: #fcae6a; color: black;',
				'background: #fcd16a; color: black;',
				'background: #8cd1ff; color: black;',
				'background: #a5d8fa; color: black;'
			);
			console.log('↪', ...args);
		},
	},
};

const install = (instance = Vue) => instance.mixin(mixin);
export { install, mixin };
